




























import moment from 'moment'
    
export default {
    name: 'GatheringHome',
    data: ()->
        return {
            year: moment().year()
        }
}
